import React, { useState, useEffect } from 'react'
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Grid, Pagination, Container, Card, Button, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BsJustify } from 'react-icons/bs';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import LeadService from '../../core/services/leadsService';
import PropTypes from 'prop-types';
import { Autocomplete } from '@mui/material';
const EditLocation = ({ locationId, LocationName, ValueLatitude, ValueLongitude, radius, organization_id, AllLocation, currentPage }) => {

    const [open, setOpen] = useState(false);
    const [preferredLocation, setPreferredLocation] = useState(LocationName);
    const [latitude, setLatitude] = useState(ValueLatitude);
    const [longitude, setLongitude] = useState(ValueLongitude);
    const [angle, setAngle] = useState(radius);
    const [getOrganization, setGetOrganization] = useState();
    const [selectedOrganization, setSelectedOrganization] = useState(organization_id)
    const [Loading, setLoading] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const updateLocationData = async (locationId, preferredLocation, latitude, longitude, angle,selectedOrganization) => {
        try {

            setLoading(true)
            const res = await LeadService.updatedLocation(locationId, preferredLocation, latitude, longitude, angle,selectedOrganization);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                AllLocation(currentPage);
                setOpen(false);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setOpen(false);
            setLoading(false)
        }
    };

    const handleSaveChange = () => {
        if (!preferredLocation) {
            return toast.error('Please enter a Location');
        }
        if (!latitude) {
            return toast.error('Please enter a latitude');
        }
        if (!longitude) {
            return toast.error('Please enter a longitude');
        }
        if (!angle) {
            return toast.error('Please enter an Radius');
        }
        const radius = parseInt(angle, 10);
        if (isNaN(radius) || radius < 1 || radius > 70) {
            return toast.error('Please enter a valid number for Radius between 1 and 70');
        }
        updateLocationData(locationId, preferredLocation, latitude, longitude, angle,selectedOrganization);
    }
    const AllOrganization = async () => {
        try {
            const res = await LeadService.getOrganizations();
            if (res.data.success) {
                setGetOrganization(res.data.data);

                // const importedAgent = { id: '', organization_name: 'Imported/SelfPay Agent' };
                // const organizations = [importedAgent, ...res.data.data];

                // setGetOrganization(organizations);
                // // Set the default selected organization
                // setSelectedOrganization(importedAgent.id);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    useEffect(() => {
        AllOrganization();
    }, []);
    const HandleChangeOrigination = async (event, newValue) => {
        const newOrganizationId = newValue ? newValue.id : '';
        setSelectedOrganization(newOrganizationId);

    };
    return (
        <div>
            <EditIcon sx={{ color: '#2883CC' }}
                onClick={handleOpen}
            />

            <Modal open={open} >
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                    className="modal-resp-settings"
                >
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box style={{ padding: '20px' }}>
                        <Box style={{ display: 'flex' }}>
                            {/* <ManageAccountsIcon /> */}
                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Update Location</Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                value={preferredLocation}
                                onChange={(event, value) => setPreferredLocation(event.target.value)}
                                placeholder="Add Location"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>
                        <Box style={{ display: 'flex', marginTop: '10px' }}>

                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Update Latitude </Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                value={latitude}
                                onChange={(event, value) => setLatitude(event.target.value)}
                                placeholder="Add Latitude"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>
                        <Box style={{ display: 'flex', marginTop: '10px' }}>

                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Update longitude </Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                value={longitude}
                                onChange={(event, value) => setLongitude(event.target.value)}
                                placeholder="Add Longitude"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>

                        <Box style={{ display: 'flex', marginTop: '10px' }}>

                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Update Radius </Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                value={angle}
                                onChange={(event, value) => setAngle(event.target.value)}
                                placeholder="Add Radius"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>
                        {/* <Box style={{ display: 'flex', marginTop: '10px' }}>

                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Add Organization </Typography>
                        </Box> */}
                        {/* <Box style={{ marginTop: '10px' }}>
                            <Autocomplete
                                options={getOrganization}
                                getOptionLabel={(getOrganization) => getOrganization.organization_name}
                                renderInput={(params) => <TextField {...params} label="Select Organization" />}
                                value={getOrganization?.find((location) => location.id === selectedOrganization) || null}
                                onChange={HandleChangeOrigination}
                                // sx={{
                                //     '& .MuiOutlinedInput-root': {
                                //         borderRadius: '12px',
                                //     },
                                //     width: '416px',
                                // }}
                            />
                        </Box> */}

                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={handleClose}
                                    sx={{
                                        width: {
                                            xs: '120px',
                                            sm: '140px',
                                            md: '168px'
                                        },
                                        height: '43px',
                                        fontSize: {
                                            xs: '11px',
                                            sm: '14px',
                                            md: '16px'
                                        },
                                        backgroundColor: 'white',
                                        color: '#252F46',
                                        borderRadius: '12px',
                                        textTransform: 'capitalize',
                                        fontSize: 'auto',
                                        border: '1px solid #252F46',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        fontFamily: 'inherit',
                                    }}
                                >  Cancel</Button>
                            </Box>

                            <Box>
                                <Button
                                    onClick={handleSaveChange}
                                    variant="contained"
                                    sx={{
                                        width: {
                                            xs: '120px',
                                            sm: '140px',
                                            md: '168px'
                                        },
                                        height: '43px',
                                        fontSize: {
                                            xs: '11px',
                                            sm: '14px',
                                            md: '16px'
                                        },
                                        borderRadius: '12px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        border: '1px solid #587DBF',
                                        backgroundColor: '#5379BD',
                                        textTransform: 'capitalize',
                                        color: 'white',
                                        fontFamily: 'inherit'
                                    }}

                                    disabled={Loading} // Disable the button when loading
                                >  {Loading ? 'Saving...' : 'Update Changes'} {/* Optional: Show loading text */}</Button>
                                <LinearProgress sx={{ visibility: Loading ? '' : 'hidden' }} />
                            </Box>

                        </Box>
                    </Box>


                </Box>
            </Modal>
        </div>
    )
}

export default EditLocation
